import React, { useEffect } from 'react'
import '../styles/ConfirmDialog.css'

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger' // 'danger', 'warning', 'primary'
}) => {
  useEffect(() => {
    if (!isOpen) return

    // Handle keyboard events
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose()
      } else if (e.key === 'Enter' && !e.shiftKey) {
        onConfirm()
      }
    }

    // Focus management
    const previousActiveElement = document.activeElement
    const confirmBtn = document.querySelector('.confirm-dialog-confirm')
    if (confirmBtn) {
      confirmBtn.focus()
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      // Restore focus
      if (previousActiveElement) {
        previousActiveElement.focus()
      }
    }
  }, [isOpen, onClose, onConfirm])

  if (!isOpen) return null

  return (
    <div className="confirm-dialog-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
      <div className="confirm-dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          <h3 id="confirm-dialog-title">{title}</h3>
        </div>

        <div className="confirm-dialog-body">
          <p>{message}</p>
        </div>

        <div className="confirm-dialog-actions">
          <button
            className="btn btn-secondary"
            onClick={onClose}
            autoFocus={false}
          >
            {cancelText}
          </button>
          <button
            className={`btn btn-${variant} confirm-dialog-confirm`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDialog
